import React, {useMemo} from 'react'
import {Typography} from "antd";
import {TextProps} from "antd/es/typography/Text";
import {useTranslation} from "react-i18next";

export type LabelProps = TextProps & {
    trl: string
    segments?: {key: string, value: string}[]
};

export const Label: React.FC<LabelProps> = (props) => {
    const {trl, segments} = props;
    const {t} = useTranslation();
    const text = useMemo(() => {
        let out = t(trl);
        if (segments) {
            segments.forEach(segment => {
                out = out.replaceAll(segment.key, segment.value);
            });
        }
        return out;
    }, [t]);

    return (
        <Typography.Text {...props} >{text}</Typography.Text>
    )
}